import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "image-wrapper-header" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "image-wrapper-body" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["disabled"]

import {
  computed,
  reactive,
  useTemplateRef,
  watch,
} from 'vue';
import { downloadObjectUrl } from 'src/lib/downloadHelper';
import { dtFormat } from 'src/lib/dateHelper';

interface ModalImageViewState {
  maxWidthStr: string | null;
  currentIndex: number;
}

interface Props {
  title?: string;
  imageUrls?: string[];
  downloadFilenameTemplate?: string;
  initialIndex?: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ModalImageView',
  props: {
    title: { default: '' },
    imageUrls: { default: () => [] },
    downloadFilenameTemplate: { default: '' },
    initialIndex: { default: 0 }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const refImg1 = useTemplateRef<HTMLImageElement>('refImg1');
const state = reactive<ModalImageViewState>({
  maxWidthStr: null,
  currentIndex: props.initialIndex,
});

watch(
  [() => props.initialIndex, () => props.imageUrls],
  ([newIndex]) => {
    state.currentIndex = newIndex;
  },
);

const currentImageUrl = computed<string>(() => {
  return props.imageUrls[state.currentIndex] ?? '';
});

const onImageLoad = () => {
  // DOMの表示上のサイズを取得する
  const imgDispWidth = refImg1.value?.width || 0;
  const imgDispHeight = refImg1.value?.height || 0;
  if (imgDispWidth <= imgDispHeight) {
    state.maxWidthStr = null;
    return;
  }
  // 画像が横長の場合は横幅のmaxを広げる
  state.maxWidthStr = '75%';
};
const trimmedTitle = computed<string>(() => {
  const maxLen = state.maxWidthStr !== null ? 46 : 22;
  return props.title.length > maxLen
    ? `${props.title.slice(0, maxLen)}...`
    : props.title;
});
const downloadImage = () => {
  const timestamp = dtFormat(new Date(), 'yyyymmddHHMMSS');
  const downloadFilename = props.downloadFilenameTemplate.replace(/\$TIMESTAMP/, timestamp);
  downloadObjectUrl(currentImageUrl.value, downloadFilename);
};
const onClose = () => {
  emit('close');
};
const showPrevious = () => {
  if (state.currentIndex > 0) {
    state.maxWidthStr = null;
    state.currentIndex--;
  }
};
const showNext = () => {
  if (state.currentIndex < props.imageUrls.length - 1) {
    state.maxWidthStr = null;
    state.currentIndex++;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    "show-footer": false,
    "show-top-dismiss-button": false,
    "max-width-str": state.maxWidthStr ?? undefined
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(trimmedTitle.value), 1),
        _createElementVNode("div", {
          class: "download-btn mr12",
          onClick: downloadImage
        }, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("i", { class: "fa fa-download" }, null, -1)
        ]))]),
        _createElementVNode("div", {
          class: "close-btn",
          onClick: onClose
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("i", { class: "fas fa-times" }, null, -1)
        ]))])
      ])
    ]),
    body: _withCtx((slotProps) => [
      _createElementVNode("div", _hoisted_3, [
        (__props.imageUrls.length > 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "nav-btn nav-btn-prev",
              disabled: state.currentIndex <= 0,
              "aria-label": "前の画像",
              onClick: showPrevious
            }, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1)
            ]))], 8, _hoisted_4))
          : _createCommentVNode("", true),
        _createElementVNode("img", {
          ref_key: "refImg1",
          ref: refImg1,
          class: "img",
          src: currentImageUrl.value,
          onLoad: onImageLoad,
          style: _normalizeStyle({
            'max-height': (slotProps.modalBodyMaxHeight - 16 * 2) + 'px'
          })
        }, null, 44, _hoisted_5),
        (__props.imageUrls.length > 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "nav-btn nav-btn-next",
              disabled: state.currentIndex >= __props.imageUrls.length - 1,
              "aria-label": "次の画像",
              onClick: showNext
            }, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("i", { class: "fas fa-chevron-right" }, null, -1)
            ]))], 8, _hoisted_6))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["max-width-str"]))
}
}

})